module.exports = __webpack_public_path__ + "static/WEDDING E&M-482-661582db018a3844271e305fcea0e256.jpg";